export const GET_META_SOCIAL_MEDIA_STARTED = "GET_META_SOCIAL_MEDIA_STARTED"
export const GET_META_SOCIAL_MEDIA_SUCCESS = "GET_META_SOCIAL_MEDIA_SUCCESS"
export const GET_META_SOCIAL_MEDIA_FAILURE = "GET_META_SOCIAL_MEDIA_FAILURE"

export const LINK_FACEBOOK_PAGE_STARTED = "LINK_FACEBOOK_PAGE_STARTED"
export const LINK_FACEBOOK_PAGE_SUCCESS = "LINK_FACEBOOK_PAGE_SUCCESS"
export const LINK_FACEBOOK_PAGE_FAILURE = "LINK_FACEBOOK_PAGE_FAILURE"

export const LOG_OUT_META_STARTED = "LOG_OUT_META_STARTED"
export const LOG_OUT_META_SUCCESS = "LOG_OUT_META_SUCCESS"
export const LOG_OUT_META_FAILURE = "LOG_OUT_META_FAILURE"

export const GET_FACEBOOK_PAGES_STARTED = "GET_FACEBOOK_PAGES_STARTED"
export const GET_FACEBOOK_PAGES_SUCCESS = "GET_FACEBOOK_PAGES_SUCCESS"
export const GET_FACEBOOK_PAGES_FAILURE = "GET_FACEBOOK_PAGES_FAILURE"

export const GET_META_POSTS_STARTED = "GET_META_POSTS_STARTED"
export const GET_META_POSTS_SUCCESS = "GET_META_POSTS_SUCCESS"
export const GET_META_POSTS_FAILURE = "GET_META_POSTS_FAILURE"

export const GET_SOCIAL_POSTS_STARTED = "GET_SOCIAL_POSTS_STARTED"
export const GET_SOCIAL_POSTS_SUCCESS = "GET_SOCIAL_POSTS_SUCCESS"
export const GET_SOCIAL_POSTS_FAILURE = "GET_SOCIAL_POSTS_FAILURE"

export const CREATE_SOCIAL_POST_STARTED = "CREATE_SOCIAL_POST_STARTED"
export const CREATE_SOCIAL_POST_SUCCESS = "CREATE_SOCIAL_POST_SUCCESS"
export const CREATE_SOCIAL_POST_FAILURE = "CREATE_SOCIAL_POST_FAILURE"

export const ADD_COMMENT_STARTED = "ADD_COMMENT_STARTED"
export const ADD_COMMENT_SUCCESS = "ADD_COMMENT_SUCCESS"
export const ADD_COMMENT_FAILURE = "ADD_COMMENT_FAILURE"

export const REPLY_COMMENT_STARTED = "REPLY_COMMENT_STARTED"
export const REPLY_COMMENT_SUCCESS = "REPLY_COMMENT_SUCCESS"
export const REPLY_COMMENT_FAILURE = "REPLY_COMMENT_FAILURE"

export const REMOVE_ERROR_MESSAGE = "REMOVE_ERROR_MESSAGE"
